import React from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../Forms/Form/Form.js';

import './CheckoutBill.css'; 

class CheckoutBill extends React.Component {
  
  parent = {};

  constructor(props) {
      super(props);
      
      this.state = {
        show: false,
        hiding: false,
        formData: {},
    };
  }

  show(parent = null) {
    this.setState({show: true});
    if(parent){
      this.parent = parent;
    }
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle(parent = null) {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show(parent);
    }
  }

  set_form_data(formData,callback)
  {
    this.setState({formData:formData},()=>{
      if(typeof callback=='function'){ callback(); }
    });
  }

  handle_change(event, formDataKey, force_value = null) {
    const formData = this.state.formData;

    formData[formDataKey] = force_value !== null ? force_value : event.target.value;

    this.setState({formData});
  }

  handle_submit(e) {
    e.preventDefault();
    this.hide();
  }

  render() {

    const {formData, formErrors, show, hiding } = this.state;

    if (!show) return '';

    return <div className={`container floating_container page_checkout page_checkout_bill ${hiding ? 'out' : ''}`}>
          <div className="content">
            <PageHeader parent_ref={this} no_close title={i18n.t('checkoutData')} />
            <div className='container_inner'>
            <Form 
              key={formData.form_hash}
              name="checkout_bill" 
              form_data={formData} 
              on_save={(form_data,callback)=>{this.parent.set_from_data_from_step('1',form_data,callback)}} 
              form_source="props" 
              submit_text={i18n.t('save')} 
              parent={this} />
            </div> 
          </div>
      </div>;
  }

  show_bill_address_fields() {
    const {formData, formErrors } = this.state;
    
    return <div className="bill_address_fields">
      <label>{i18n.t('checkoutBillAddress')}</label>

      <div className="row">
        <div className={`field ${formErrors.country !== '' ? "error" : ""}`}>
          <div className="select">
              <select defaultValue="0" onChange={(e) => this.handle_change(e, 'country')}>
                <option value="0">Magyarország</option>
                <option value="1">Románia</option>
              </select>
              <ReactSVG src="assets/images/arrow_down.svg" />
            </div>
            {(formErrors.country.length) ? <div className="form_error">{formErrors.country}</div> : '' } 
        </div> 
      </div> 
      <div className="row">
        <div className={`field ${formErrors.zip !== '' ? "error" : ""}`}>
            <input placeholder={`${i18n.t('checkoutZip')} *`} type="text" value={formData.zip} onChange={(e) => this.handle_change(e, 'zip')} />
            {(formErrors.zip.length) ? <div className="form_error">{formErrors.zip}</div> : '' } 
        </div> 
      </div> 
      <div className="row">
        <div className={`field ${formErrors.city !== '' ? "error" : ""}`}>
            <input placeholder={`${i18n.t('checkoutCity')} *`} type="text" value={formData.city} onChange={(e) => this.handle_change(e, 'city')} />
            {(formErrors.city.length) ? <div className="form_error">{formErrors.city}</div> : '' } 
        </div> 
      </div> 
      <div className="row">
        <div className={`field ${formErrors.address !== '' ? "error" : ""}`}>
            <input placeholder={`${i18n.t('checkoutAddress')} *`} type="text" value={formData.address} onChange={(e) => this.handle_change(e, 'address')} />
            {(formErrors.address.length) ? <div className="form_error">{formErrors.address}</div> : '' } 
        </div>
      </div>
      <div className="row">
        <div className={`field order_comment ${formErrors.order_comment !== '' ? "error" : ""}`}>
          <label className="field_label">{i18n.t('checkoutOrderComment')}</label>  
          <textarea onChange={(e) => this.handle_change(e, 'order_comment')} defaultValue={formData.order_comment}></textarea>
          {(formErrors.order_comment.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.order_comment}}></div> : '' }
          {(formErrors.summary.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.summary}}></div> : '' }
          <label className="field_label">{i18n.t('checkoutRequiredFields')}</label>  
        </div>
      </div> 

    </div>;
  }
}

export default CheckoutBill;